import { render, staticRenderFns } from "./ModalEditarTermo.vue?vue&type=template&id=a275dbce&scoped=true&"
import script from "./ModalEditarTermo.vue?vue&type=script&lang=js&"
export * from "./ModalEditarTermo.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditarTermo.vue?vue&type=style&index=0&id=a275dbce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a275dbce",
  null
  
)

export default component.exports